import { render, staticRenderFns } from "./BaseCheckBox.vue?vue&type=template&id=27428c5a&scoped=true&"
import script from "./BaseCheckBox.vue?vue&type=script&lang=js&"
export * from "./BaseCheckBox.vue?vue&type=script&lang=js&"
import style0 from "./BaseCheckBox.vue?vue&type=style&index=0&id=27428c5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27428c5a",
  null
  
)

export default component.exports